import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import {
  Heading,
  Text,
  Icon,
  TextWithTooltip,
  Button
} from 'components/common/Elements/Elements';

import classes from './PlatformApplicationsInfo.module.scss';

const PlatformApplicationsInfo = ({ app, handleOpenAPP, idOpenDataApp }) => {
  const { t } = useTranslation(['activity']);

  useEffect(() => {
    if (idOpenDataApp) {
      const node = document.getElementById(idOpenDataApp);
      if (node) {
        node.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }
  }, [idOpenDataApp]);

  return (
    <div className={classes.info}>
      <div className={cn(classes.info_wrap, classes.overflow)}>
        <Heading className={classes.info_title}>
          {t('activity:platform.NETWORK')}
        </Heading>
        <Text className={classes.info_text}>
          {app.networkName ? <TextWithTooltip text={app.networkName} /> : 'NA'}
        </Text>
      </div>
      <div className={cn(classes.info_wrap, classes.overflow)}>
        <Heading className={classes.info_title}>
          {t('activity:platform.ACCESS_GROUPS_AND_USERS')}
        </Heading>
        <Text className={classes.info_text}>
          {app.accessGroups &&
          app.accessGroups !== '-' &&
          app.accessGroups !== 'NA' ? (
            <TextWithTooltip text={app.accessGroups.join(', ')} />
          ) : (
            'NA'
          )}
        </Text>
      </div>
      <div className={cn(classes.info_wrap, classes.overflow)}>
        <Heading className={classes.info_title}>
          {t('activity:platform.POLICY')}
        </Heading>
        <Text className={classes.info_text}>
          {app.policyName ? <TextWithTooltip text={app.policyName} /> : 'NA'}
        </Text>
      </div>
      <Button
        className={classes.arrowWrap}
        onClick={() => handleOpenAPP(app.appId)}
        id={app.appId}
      >
        <Icon
          size={'32px'}
          icon="arrow"
          color="#3a5ba2"
          className={idOpenDataApp !== app.appId ? '' : classes.iconUp}
        />
        <span className={classes.visually_hidden}>Open to details</span>
      </Button>
    </div>
  );
};

PlatformApplicationsInfo.propTypes = {
  app: PropTypes.object,
  handleOpenAPP: PropTypes.func.isRequired,
  idOpenDataApp: PropTypes.string
};

export default PlatformApplicationsInfo;
